const { NEB_ENV: { GOOGLE_API_KEY } = {} } = window;

// eslint-disable-next-line no-template-curly-in-string
const API_KEY = GOOGLE_API_KEY !== '${GOOGLE_API_KEY}' ? GOOGLE_API_KEY : '';

const __loadedPromise = new Promise(resolve => {
  const script = document.createElement('script');

  script.onload = () => {
    resolve();
  };

  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;

  document.head.appendChild(script);
});
/**
 * A mixin for using the maps API.
 * @param {Class} superClass
 */

export const NebMapsApiMixin = superClass =>
  class extends superClass {
    static get properties() {
      return {
        /** Will be true when the component is fully initialized and ready. */
        initialized: {
          type: Boolean,
          notify: true,
        },
        _key: {
          type: String,
          value: API_KEY,
        },
        _staticMapUrl: {
          type: String,
          value: 'https://maps.googleapis.com/maps/api/staticmap',
        },
        _gMapsPlacesUrl: {
          type: String,
          value: 'https://www.google.com/maps/place/',
        },
        _aMapsUrl: {
          type: String,
          value: 'http://maps.apple.com/?q=',
        },
      };
    }

    constructor() {
      super();

      __loadedPromise.then(() => {
        this._onLoad();
      });
    }
  };
